<template>
  <div class="pb-2 section">
    <div class="container">
      <div class="container__inner px-1.5">
        <div class="lg:w-8/12">
          <form name="quiz-form" class="quiz-form" method="post">
            <p class="p-0 py-2 m-0 text-xl lg:text-4xl lg:pb-2" id="quiz_block">
              {{ question.title }}
            </p>

            <div
              v-if="question.description"
              class="pb-2"
              v-html="question.description"
            ></div>

            <div v-if="question.media" class="pb-2">
              <img :src="question.media.guid" />
            </div>

            <textarea
              class="w-full border border-solid border-dark rounded-2xl p-1.5 mb-1 text-base lg:text-lg"
              id="answer"
              placeholder="Votre réponse"
              @change="change($event.target.value)"
              :value="choices"
            ></textarea>
            <div class="py-2 lg:py-4">
              <button
                type="button"
                class="bt"
                @click="$emit('nextQuestion')"
                :disabled="choices.length === 0"
              >
                <span>Question suivante</span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { ref } from "vue";
const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(["update:modelValue", "nextQuestion"]);
const choices = ref(props.modelValue);
const change = (id) => {
  choices.value = [id];
  emit("update:modelValue", choices.value);
};
</script>
